const GTM_SRC_BASE = 'https://www.googletagmanager.com/gtm.js'

export function initGtm() {
  const gtmId = import.meta.env.VITE_GTM_ID

  if (!gtmId || typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  // Idempotency across HMR / re-entry.
  if (window.__NXT_GTM_INITIALIZED__) {
    return
  }
  window.__NXT_GTM_INITIALIZED__ = true

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `${GTM_SRC_BASE}?id=${encodeURIComponent(gtmId)}&l=dataLayer`
  document.head.appendChild(script)
}

